module.exports = __webpack_public_path__ + "img/8.c70ab35e.jpg";